import { useState } from 'react'

import { Banner, FormattedMessage } from '@b-stock/fe-core/bstock-react'

const ns = 'Offerings.Details.offeringStatusBanner.contractBannerInfo'

export const ContractBannerInfo = () => {
  const [isDismissed, setIsDismissed] = useState(false)

  return (
    !isDismissed && (
      <Banner title={null} onDismiss={() => setIsDismissed(true)}>
        <FormattedMessage id={`${ns}.message`} />
      </Banner>
    )
  )
}
